import type {DebounceSettings} from 'lodash';
import debounce from 'lodash/debounce';
import memoize from 'lodash/memoize';

type Options<A1, A2> = DebounceSettings & {
    resolver?: (a1: A1, a2: A2) => string;
};

export default function debounceWithResolver<A1, A2, R>(
    func: (a1: A1, a2: A2) => R,
    waitTime = 0,
    {resolver = (a1: A1) => String(a1), ...options}: Options<A1, A2> = {}
) {
    const cache = new memoize.Cache();
    return function (a1: A1, a2: A2): R {
        const key = resolver(a1, a2);
        cache.set(key, cache.get(key) || debounce(func, waitTime, options));
        return cache.get(key)(a1, a2);
    };
}
